module.exports = __webpack_public_path__ + "static/media/info.f9a03aa2.jpeg";